<template>
	<editor
		:show.sync="editorVisible"
		:title="title"
		:alert-info="alertInfo"
		:data-model-name="editorDataModel"
		:record-id="recordId"
		:fields="editorFields"
		:handler-url="handlerUrl"
		@change="doChange"
		:check-ever-edited="false"
		v-if="editorVisible"
	></editor>
</template>

<script>
export default {
	data() {
		return {
			editorDataModel: "Order",
			editorFields: [
				{
					name: "customer",
					isOnlyShow: true,
					col: 6
				},
				{
					name: "express_type",
					isOnlyShow: true,
					col: 6
				},
				{
					name: "address",
					isOnlyShow: true,
					params: {
						nameFields: ["name"]
					},
					col: 6
				},
				{
					name: "total_price",
					isOnlyShow: true,
					col: 6
				},
				{
					name: "cancel_reason_code",
					col: 6
				},
				{
					name: "desc",
					col: 6
				}
			]
		};
	},
	computed: {
		editorVisible: {
			get: function() {
				return this.show;
			},
			set: function(val) {
				this.$emit("update:show", val);
			}
		},
		title() {
			return "";
		},
		alertInfo() {
			return "";
		},
		handlerUrl() {
			return "orderm/do_cancel_order/";
		}
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		recordId: {
			type: String,
			default: ""
		}
	},
	methods: {
		doChange(val) {
			this.$emit("change", val);
		}
	}
};
</script>